<template>
   <header v-if="editor">
      <!-- Undo -->
      <button
         class="btn-icon"
         @click="editor.chain().focus().undo().run()"
         :disabled="!editor.can().undo()"
      >
         <span class="material-icons"> undo </span>
         <span class="tooltip">Ongedaan maken</span>
      </button>

      <!-- Redo -->
      <button
         class="btn-icon"
         @click="editor.chain().focus().redo().run()"
         :disabled="!editor.can().redo()"
      >
         <span class="material-icons"> redo </span>
         <span class="tooltip">Opnieuw</span>
      </button>

      <div class="separator"></div>

      <!-- Header 1 -->
      <button
         class="header1 btn-icon"
         @click="editor.chain().focus().toggleHeading({ level: 1 }).run()"
         :class="{
            'is-active': editor.isActive('heading', { level: 1 }),
         }"
      >
         <span>H1</span>
         <span class="tooltip">Koptekst</span>
      </button>

      <!-- Header 2 -->
      <button
         class="btn-icon"
         @click="editor.chain().focus().toggleHeading({ level: 2 }).run()"
         :class="{ 'is-active': editor.isActive('heading', { level: 2 }) }"
      >
         <span>H2</span>
         <span class="tooltip">H2</span>
      </button>

      <!-- Header 3 -->
      <button
         class="btn-icon"
         @click="editor.chain().focus().toggleHeading({ level: 3 }).run()"
         :class="{ 'is-active': editor.isActive('heading', { level: 3 }) }"
      >
         <span>H3</span>
         <span class="tooltip">H3</span>
      </button>

      <div class="separator"></div>

      <!-- Bold -->
      <button
         class="btn-icon"
         @click="editor.chain().focus().toggleBold().run()"
         :class="{ 'is-active': editor.isActive('bold') }"
      >
         <span class="material-icons"> format_bold </span>
         <span class="tooltip">Vet</span>
      </button>

      <!-- Italic -->
      <button
         class="btn-icon"
         @click="editor.chain().focus().toggleItalic().run()"
         :class="{ 'is-active': editor.isActive('italic') }"
      >
         <span class="material-icons"> format_italic </span>
         <span class="tooltip">Cursief</span>
      </button>

      <!-- Strikethrough -->
      <button
         class="btn-icon"
         @click="editor.chain().focus().toggleStrike().run()"
         :class="{ 'is-active': editor.isActive('strike') }"
      >
         <span class="material-icons"> strikethrough_s </span>
         <span class="tooltip">Onderstrepen</span>
      </button>

      <!-- Superscript -->
      <button
         class="btn-icon"
         @click="editor.chain().focus().toggleSuperscript().run()"
         :class="{ 'is-active': editor.isActive('superscript') }"
      >
         <span class="material-icons"> superscript </span>
         <span class="tooltip">Superscript</span>
      </button>

      <!-- Subscript -->
      <button
         class="btn-icon"
         @click="editor.chain().focus().toggleSubscript().run()"
         :class="{ 'is-active': editor.isActive('subscript') }"
      >
         <span class="material-icons"> subscript </span>
         <span class="tooltip">Subscript</span>
      </button>

      <!-- Bulleted list -->
      <button
         class="btn-icon"
         @click="editor.chain().focus().toggleBulletList().run()"
         :class="{ 'is-active': editor.isActive('bulletList') }"
      >
         <span class="material-icons">format_list_bulleted</span>
         <span class="tooltip">Lijst met opsommingsteken</span>
      </button>

      <!-- Ordered list -->
      <button
         class="btn-icon"
         @click="editor.chain().focus().toggleOrderedList().run()"
         :class="{ 'is-active': editor.isActive('orderedList') }"
      >
         <span class="material-icons">format_list_numbered</span>
         <span class="tooltip">Genummerde lijst</span>
      </button>

      <div class="separator"></div>

      <!-- Link -->
      <button
         class="btn-icon"
         @click="$emit('setLink')"
         :class="{ 'is-active': editor.isActive('link') }"
      >
         <span class="material-icons"> link </span>
         <span class="tooltip">Link invoegen</span>
      </button>
      <button
         class="btn-icon"
         @click="editor.chain().focus().unsetLink().run()"
         :disabled="!editor.isActive('link')"
      >
         <span class="material-icons"> link_off </span>
         <span class="tooltip">Link verwijderen</span>
      </button>

      <div class="separator"></div>

      <!-- Table -->
      <button
         class="btn-icon"
         @click="
            editor
               .chain()
               .focus()
               .insertTable({ rows: 3, cols: 2, withHeaderRow: true })
               .run()
         "
      >
         <span class="material-icons"> calendar_view_month </span>
         <span class="tooltip">Tabel invoegen</span>
      </button>

      <!-- More options -->
      <!-- <div
         class="dropdown"
         @mouseover="showMoreOptions = true"
         @mouseout="showMoreOptions = false"
      >
         <button class="btn-icon">
            <span class="material-icons">add</span>
         </button>
         <div class="dropdown-content" @mouseover="showMoreOptions = true" v-show="showMoreOptions">
            <button @click="$emit('lijstaanhef');showMoreOptions = false">Lijstaanhef</button>
            <button @click="$emit('lijstsluiting');showMoreOptions = false">Lijsluiting</button>
            <hr />
            <button @click="$emit('ExtRef');showMoreOptions = false">ExtRef</button>
            <button @click="$emit('ExtIoRef');showMoreOptions = false">ExtIoRef</button>
            <button @click="$emit('IntRef');showMoreOptions = false">IntRef</button>
            <button @click="$emit('IntIoRef');showMoreOptions = false">IntIoRef</button>
            <hr/>




            <button
               @click="
                  $emit('addIllustration');
                  showMoreOptions = false;
               "
            >
               Illustratie
            </button>
            <button
               @click="
                  $emit('addKop');
                  showMoreOptions = false;
               "
            >
               Kop
            </button>
            <button
               @click="
                  $emit('addCitaat');
                  showMoreOptions = false;
               "
            >
               Citaat
            </button>
         </div>
      </div> -->
      <!-- Table options -->
      <div
         class="tableOptions"
         v-show="
            editor.can().addColumnBefore() ||
            editor.can().addColumnAfter() ||
            editor.can().deleteColumn() ||
            editor.can().addRowBefore() ||
            editor.can().addRowAfter() ||
            editor.can().deleteRow() ||
            editor.can().deleteTable() ||
            editor.can().mergeCells() ||
            editor.can().splitCell() ||
            editor.can().toggleHeaderRow()
         "
      >
         <button
            @click="editor.chain().focus().addColumnBefore().run()"
            :disabled="!editor.can().addColumnBefore()"
         >
            addColumnBefore
         </button>
         <button
            @click="editor.chain().focus().addColumnAfter().run()"
            :disabled="!editor.can().addColumnAfter()"
         >
            addColumnAfter
         </button>
         <button
            @click="editor.chain().focus().deleteColumn().run()"
            :disabled="!editor.can().deleteColumn()"
         >
            deleteColumn
         </button>
         <div class="separator"></div>
         <button
            @click="editor.chain().focus().addRowBefore().run()"
            :disabled="!editor.can().addRowBefore()"
         >
            addRowBefore
         </button>
         <button
            @click="editor.chain().focus().addRowAfter().run()"
            :disabled="!editor.can().addRowAfter()"
         >
            addRowAfter
         </button>
         <button
            @click="editor.chain().focus().deleteRow().run()"
            :disabled="!editor.can().deleteRow()"
         >
            deleteRow
         </button>
         <div class="separator"></div>
         <button
            @click="editor.chain().focus().deleteTable().run()"
            :disabled="!editor.can().deleteTable()"
         >
            deleteTable
         </button>
         <button
            @click="editor.chain().focus().mergeCells().run()"
            :disabled="!editor.can().mergeCells()"
         >
            mergeCells
         </button>
         <button
            @click="editor.chain().focus().splitCell().run()"
            :disabled="!editor.can().splitCell()"
         >
            splitCell
         </button>
         <div class="separator"></div>
         <button
            @click="editor.chain().focus().toggleHeaderRow().run()"
            :disabled="!editor.can().toggleHeaderRow()"
         >
            toggleHeaderRow
         </button>
      </div>
   </header>
</template>

<script>
export default {
   props: ["editor"],
   data() {
      return {
         showMoreOptions: false,
      };
   },
};
</script>


<style scoped lang="scss">
header {
   padding: 0.5rem;
   background-color: var(--menu-bg-color, #fff);
   display: flex;
   flex-wrap: wrap;
   align-items: center;
   gap: 8px;
   border-bottom: var(--border, 1px solid #ddd);
   .btn-icon {
      width: 40px;
      height: 40px;
      border-radius: 50%;
   }
   button {
      background-color: transparent;
      border: 0;
      outline: none;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      position: relative;
      &:hover {
         background-color: var(--header-hover-color);
         .tooltip {
            opacity: 1;
            transition: opacity 0.6s ease;
         }
      }
      &.is-active {
         background-color: #ccc;
      }
      &:disabled {
         pointer-events: none;
      }
   }
   .tableOptions {
      flex-basis: 100%;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 8px;
      button {
         width: initial;
      }
   }
}
.separator {
   width: 1px;
   height: 24px;
   background-color: var(--border-color, #ddd);
}
.tooltip {
   position: absolute;
   background-color: #555;
   color: #fff;
   text-align: center;
   padding: 5px 8px;
   border-radius: 6px;
   z-index: 1;
   opacity: 0;
   font-size: 1rem;
   bottom: 125%;
   left: 50%;
   transform: translateX(-50%);
   pointer-events: none;
   &::after {
      content: "";
      position: absolute;
      top: 100%;
      left: 50%;
      margin-left: -5px;
      border-width: 5px;
      border-style: solid;
      border-color: #555 transparent transparent transparent;
   }
}

.dropdown {
   position: relative;
   hr {
      height: 1px;
      border: 0;
      background-color: #ddd;
   }
   .dropdown-content {
      // display: none;
      position: absolute;
      top: 100%;
      right: 0;
      min-width: 160px;
      background-color: #fff;
      box-shadow: var(--box-shadow);
      z-index: 1;
      padding: 8px 0;
      button {
         display: block;
         padding: 0.5rem 1rem;
         width: 100%;
         font-size: 1rem;
         text-align: left;
      }
   }
   &:hover {
      .btn-icon {
         background-color: var(--header-hover-color);
      }
      .dropdown-content {
         //   display: block;
      }
   }
}
</style>